module.exports = __webpack_public_path__ + "static/achieve-c7a67ddc581e03642b21c3675c24c70c.jpg";